import type { Narrative } from '../../hooks/useNarrative';
import { getDisclaimer } from './utils';

export interface Props {
  userHoldsPosition: boolean | null | undefined;
  authorDisplayName: string | null | undefined;
  companyTicker: string | null | undefined;
  disclaimerType: Narrative['owner']['disclaimerType'];
}

export const NarrativeDisclaimer = ({
  userHoldsPosition,
  companyTicker,
  authorDisplayName,
  disclaimerType,
}: Props) => {
  const content = getDisclaimer({
    userHoldsPosition,
    companyTicker,
    authorDisplayName,
    disclaimerType,
  });
  if (!content) return null;
  return (
    <section
      className="grid w-full rounded-none bg-surface-1 p-x3 py-x2 lg:rounded-x1"
      data-cy-id="narrative-disclaimer"
    >
      <h2 className="m-0 mb-x0_5 line-clamp-2 text-sm font-normal text-softer">
        Disclaimer
      </h2>
      <p className="m-0 text-xs italic text-soft">{content}</p>
    </section>
  );
};
